import styled from 'styled-components';

export const SectionLabel = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamilies.mono};
  font-size: ${({ theme }) => theme.typography.fontSizes.monoMd};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacings.widest};
  text-transform: uppercase;
  color: ${({ theme }) => theme.ink[3]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.typography.fontFamilies.serif};
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  font-size: ${({ theme }) => theme.typography.fontSizes.hLg};
  line-height: ${({ theme }) => theme.typography.lineHeights.snug};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacings.tight};
  font-variation-settings: 'opsz' 60;
  max-width: ${({ theme }) => theme.widths.reading};
  margin-bottom: ${({ theme }) => theme.spacing[8]};

  em {
    font-family: ${({ theme }) => theme.typography.fontFamilies.serifEd};
    font-style: italic;
    color: ${({ theme }) => theme.tone.halo.base};
    font-variation-settings: normal;
  }

  @media (max-width: 600px) {
    font-size: ${({ theme }) => theme.typography.fontSizes.hMd};
  }
`;

export const SectionLede = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSizes.bodyLg};
  color: ${({ theme }) => theme.ink[2]};
  max-width: ${({ theme }) => theme.widths.reading};
  line-height: ${({ theme }) => theme.typography.lineHeights.relaxed};
  margin-bottom: ${({ theme }) => theme.spacing[11]};
`;

export const ColHead = styled.div`
  font-family: ${({ theme }) => theme.typography.fontFamilies.mono};
  font-size: ${({ theme }) => theme.typography.fontSizes.monoMd};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.ink[3]};
  margin-bottom: ${({ theme }) => theme.spacing[5]};
  padding-bottom: ${({ theme }) => theme.spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.line.soft};
`;
